import type { RouteRecordRaw } from 'vue-router'
const supportRoutes: RouteRecordRaw = {
  path: '/support', name: 'Support', redirect: '/support/issue',
  meta: { title: '售后工单', icon: 'icon-tool' },
  children: [
    { path: 'issue', name: 'SupportIssue', component: () => import('@/views/support/IssueList.vue'), meta: { title: '工单管理' } },
    { path: 'sla', name: 'SupportSLA', component: () => import('@/views/support/SlaList.vue'), meta: { title: 'SLA协议' } },
    { path: 'warranty', name: 'SupportWarranty', component: () => import('@/views/support/WarrantyList.vue'), meta: { title: '质保索赔' } },
  ],
}
export default supportRoutes
